import { Badge } from "@repo/ui/components/ui/badge";

const tones = {
  pending: "bg-warning/10 text-warning",
  progress: "bg-info/10 text-info",
  success: "bg-success/10 text-success",
  error: "bg-destructive/10 text-destructive",
};

export function OrderSetFooterStatus({
  label,
  message,
  tone,
}: {
  label: string;
  message?: string;
  tone: keyof typeof tones;
}) {
  return (
    <output className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-sm">
      <Badge variant="secondary" className={tones[tone]}>
        {label}
      </Badge>
      {message && (
        <>
          <span className="sr-only"> · </span>
          <span className="min-w-0 text-muted-foreground" title={message}>
            {message}
          </span>
        </>
      )}
    </output>
  );
}
